<template>
  <div id="modalSystemDiagramSelection" class="modal modal-overlay" @click.self="$emit('close')">
    <div class="system-diagram-modal">
      <div class="container">
        <div class="modal-header">
          <h2>系統図を選択してください</h2>
          <button class="close-button" @click="$emit('close')">
            <div class="close-button__line close-button__line--first" @click="$emit('close')"></div>
            <div class="close-button__line close-button__line--second" @click="$emit('close')"></div>
          </button>
        </div>
        <div class="form">
          <div class="select-box">
            <select class="form-select"
              name ="systemDiagramId"
              v-model="systemDiagramId"
              data-vv-as="系統図画像ファイル"
              v-validate="'excluded:0'" >
              <option 
                v-for="(option, index) in systemDiagramInfoList" 
                v-bind:value="option.id"
                v-bind:key="index" >{{ option.name }}</option>
            </select>
          </div>
          <div class="err_message" v-show="errors.has('systemDiagramId')">
            系統図の背景ファイルを選択してください
          </div>
          <div class="submit_area">
            <input type="submit" class="submit" value="選択" @click="onSelect" />
            <input type="button" class="submit" value="新規作成" @click="onRegister" />
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "system-diagram-selection-dialog",
  data: function() {
    return {
        systemDiagramId: 0,
    }
  },
  props: {
    systemDiagramInfoList: Array
  },
  mounted: function () {
    console.log("system-diagram-selection-dialog:mounted");
  },
  methods: {
    onSelect: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('onSelectDiagram', this.systemDiagramId);
        }
      });
    },
    onRegister: function() {
      this.$emit('onShowRegisterDiagram');
    },
    
  }
};
</script>
